import { createSlice, type PayloadAction } from "@reduxjs/toolkit"
import type { Project } from "@/src/types"

interface PortfolioState {
  projects: Project[]
  selectedProject: Project | null
}

const mockProjects: Project[] = [
  {
    id: 1,
    title: "Сучасна квартира в центрі",
    location: "Львів, вул. Городоцька",
    area: 65,
    duration: "45 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Повний ремонт двокімнатної квартири з сучасним дизайном. Проект включав повну перепланування простору, встановлення нових комунікацій, якісне оздоблення та меблювання. Особлива увага приділялася створенню комфортного та функціонального простору для молодої сім'ї.",
    price: "850$",
  },
  {
    id: 2,
    title: "Елітний ремонт",
    location: "Львів, вул. Свенціцького",
    area: 120,
    duration: "60 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Преміум ремонт з дизайнерськими рішеннями та використанням матеріалів найвищої якості. Проект включав створення індивідуального дизайну, встановлення системи розумного дому, використання натуральних матеріалів та створення унікальних декоративних елементів.",
    price: "1300$",
  },
  {
    id: 3,
    title: "Косметичний ремонт",
    location: "Львів, вул. Личаківська",
    area: 45,
    duration: "20 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Швидкий косметичний ремонт однокімнатної квартири з оновленням всіх поверхонь. Проект включав фарбування стін, заміну підлогового покриття, оновлення сантехніки та електрики. Роботи виконувалися з мінімальними незручностями для мешканців.",
    price: "550$",
  },
  {
    id: 4,
    title: "Лофт-студія",
    location: "Львів, вул. Промислова",
    area: 80,
    duration: "50 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Створення сучасної лофт-студії з відкритим плануванням та індустріальними елементами. Проект включав збереження автентичних деталей, створення багаторівневого освітлення та використання сучасних технологій.",
    price: "950$",
  },
  {
    id: 5,
    title: "Сімейний будинок",
    location: "Львів, вул. Зелена",
    area: 150,
    duration: "90 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Комплексний ремонт приватного будинку для великої сім'ї. Проект включав створення комфортних зон для всіх членів родини, облаштування дитячих кімнат, робочих зон та зон відпочинку. Особлива увага приділялася безпеці та екологічності матеріалів.",
    price: "750$",
  },
  {
    id: 6,
    title: "Офісний простір",
    location: "Львів, вул. Наукова",
    area: 200,
    duration: "40 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Ремонт та облаштування сучасного офісного простору з урахуванням потреб команди. Проект включав створення відкритих робочих зон, переговорних кімнат, зони відпочинку та сучасної IT-інфраструктури.",
    price: "650$",
  },
  {
    id: 7,
    title: "Дитяча кімната мрії",
    location: "Львів, вул. Шевченка",
    area: 25,
    duration: "15 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Створення безпечного та функціонального простору для дитини. Використання екологічних матеріалів, яскравих кольорів та розумного зонування для навчання та відпочинку.",
    price: "650$",
  },
  {
    id: 8,
    title: "Ванна кімната spa-рівня",
    location: "Львів, вул. Франка",
    area: 12,
    duration: "25 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Перетворення звичайної ванної кімнати на spa-простір з джакузі, тропічним душем та підігрівом підлоги. Використання натурального каменю та сучасних технологій.",
    price: "1200$",
  },
  {
    id: 9,
    title: "Мінімалістична квартира",
    location: "Львів, вул. Коперника",
    area: 55,
    duration: "35 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Ремонт у стилі мінімалізм з акцентом на функціональність та простоту. Використання нейтральних кольорів, прихованих систем зберігання та якісних матеріалів.",
    price: "780$",
  },
  {
    id: 10,
    title: "Кухня-острів",
    location: "Львів, вул. Пекарська",
    area: 35,
    duration: "30 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Повне перепланування кухні з створенням функціонального острова. Встановлення сучасної техніки, системи вентиляції та стильного освітлення.",
    price: "920$",
  },
  {
    id: 11,
    title: "Студія для творчості",
    location: "Львів, вул. Вірменська",
    area: 40,
    duration: "25 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Облаштування творчої студії з професійним освітленням, зонуванням для різних видів діяльності та системами зберігання матеріалів.",
    price: "680$",
  },
  {
    id: 12,
    title: "Пентхаус з терасою",
    location: "Львів, вул. Академіка Богомольця",
    area: 180,
    duration: "75 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Розкішний ремонт пентхаусу з панорамними вікнами та облаштуванням тераси. Використання преміум матеріалів та створення унікального дизайну.",
    price: "1450$",
  },
  {
    id: 13,
    title: "Гостьова кімната",
    location: "Львів, вул. Дорошенка",
    area: 20,
    duration: "18 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Створення затишної гостьової кімнати з комфортним спальним місцем, робочою зоною та системами зберігання.",
    price: "590$",
  },
  {
    id: 14,
    title: "Домашній кінотеатр",
    location: "Львів, вул. Стрийська",
    area: 30,
    duration: "40 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Облаштування домашнього кінотеатру з професійною акустикою, затемненням та комфортними меблями для перегляду фільмів.",
    price: "1100$",
  },
  {
    id: 15,
    title: "Робочий кабінет",
    location: "Львів, вул. Хмельницького",
    area: 18,
    duration: "20 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Створення функціонального робочого кабінету з ергономічним робочим місцем, системами зберігання документів та якісним освітленням.",
    price: "620$",
  },
  {
    id: 16,
    title: "Гардеробна кімната",
    location: "Львів, вул. Саксаганського",
    area: 15,
    duration: "22 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Облаштування просторої гардеробної з індивідуальними системами зберігання, дзеркалами та LED-підсвічуванням.",
    price: "750$",
  },
  {
    id: 17,
    title: "Балкон-оранжерея",
    location: "Львів, вул. Героїв УПА",
    area: 8,
    duration: "15 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Перетворення балкону на затишну оранжерею з системою поливу, освітлення для рослин та зоною відпочинку.",
    price: "580$",
  },
  {
    id: 18,
    title: "Майстерня художника",
    location: "Львів, вул. Рутковича",
    area: 45,
    duration: "28 днів",
    images: [
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
      "/placeholder.svg?height=400&width=600",
    ],
    description:
      "Облаштування професійної майстерні для художника з північним освітленням, системами вентиляції та зберігання матеріалів.",
    price: "720$",
  },
]

const initialState: PortfolioState = {
  projects: mockProjects,
  selectedProject: null,
}

const portfolioSlice = createSlice({
  name: "portfolio",
  initialState,
  reducers: {
    setSelectedProject: (state, action: PayloadAction<Project | null>) => {
      state.selectedProject = action.payload
    },
  },
})

export const { setSelectedProject } = portfolioSlice.actions
export default portfolioSlice.reducer
